import { APP_CONFIG } from '../constants/APP_CONFIG';
import { createHttpClient } from '../http/utils/createHttpClient';
import { createCache } from '../utils/cache/cache';

const client = createHttpClient({
  config: {
    responseType: 'text',
    baseURL: APP_CONFIG.services.headerFooter.baseUrl
  }
});

const cache = createCache('headerFooterService', {
  storageType: 'sessionStorage',
  defaultTtl: { hours: 12 }
});

// Uncomment for testing
// console.log('CACHE DISABLED, DO NOT COMMIT THIS LINE UNCOMMENTED', cache.clear());

export type HeaderParams = {
  user: string;
  fullName?: string;
};

/**
 * Repo:
 */
export const headerFooterService = {
  getSellHeader(identity?: HeaderParams) {
    return cache.cacheAsync(`SELL_HEADER:${JSON.stringify(identity)}`, async () => {
      const response = await client.get<string>('/manheim/header/en.html', {
        headers: {
          Authorization: identity && `Identity ${btoa(JSON.stringify(identity))}`
        }
      });
      return response.data;
    });
  },
  async getFooter() {
    return await cache.cacheAsync('FOOTER', async () => {
      const response = await client.get<string>('/manheim/footer/en.html');
      return response.data;
    });
  }
};
